import { combineReducers } from 'redux';
import types from './types';

const initialState = {
  episodeListStatus: {
    kind: 'episodeListLoading',
  },
  episodePendingDeletion: null,
};

const episodeListStatusReducer = (
  state = initialState.episodeListStatus,
  action
) => {
  switch (action.type) {
    case types.SET_EPISODE_LIST_STATUS:
      return action.payload.episodeListStatus;
    case types.RESET_STATE:
      return initialState.episodeListStatus;
    default:
      return state;
  }
};

const episodePendingDeletionReducer = (
  state = initialState.episodePendingDeletion,
  action
) => {
  switch (action.type) {
    case types.SET_EPISODE_PENDING_DELETION:
      return action.payload.episodePendingDeletion;
    case types.RESET_STATE:
      return initialState.episodePendingDeletion;
    default:
      return state;
  }
};
const reducer = combineReducers({
  episodeListStatus: episodeListStatusReducer,
  episodePendingDeletion: episodePendingDeletionReducer,
});

export default reducer;
